import { module as BaseModule } from 'modujs'
import Swiper from 'swiper'
import { Mousewheel, FreeMode } from 'swiper/modules'
import gsap from 'gsap'
import 'swiper/css' //eslint-disable-line

const isOverflown = ({
  clientWidth,
  clientHeight,
  scrollWidth,
  scrollHeight
}) => scrollHeight > clientHeight || scrollWidth > clientWidth

export default class extends BaseModule {
  init () {
    this.description = this.el.querySelector('.is-description')
    this.responsiveThreshold = 768
    window.addEventListener('resize', this.onResize.bind(this))
    this.onResize()
    this.on()
  }

  onResize () {
    this.hasOverflow = isOverflown(this.description)
    if (window.innerWidth < this.responsiveThreshold) {
      this.disableSwiper()
    } else {
      this.enableSwiper()
    }
  }

  on () {
    this.description.addEventListener('mouseenter', () => {
      if (
        !this.instance ||
        window.innerWidth < this.responsiveThreshold ||
        !this.hasOverflow
      )
        return
      this.instance.mousewheel.disable()
    })
    this.description.addEventListener('mouseleave', () => {
      if (
        !this.instance ||
        window.innerWidth < this.responsiveThreshold ||
        !this.hasOverflow
      )
        return
      this.instance.mousewheel.enable()
    })
  }

  enableSwiper () {
    if (this.instance) return

    const config = {
      modules: [Mousewheel, FreeMode],
      enabled: false,
      breakpoints: {
        768: {
          enabled: true,
          draggable: true,
          slidesPerView: 'auto',
          mousewheel: {
            enabled: true,
            eventsTarget: '.s-project'
          },
          freeMode: {
            enabled: true
          },
          grabCursor: true,
          spaceBetween: (window.innerWidth / 30) * 0.5
        }
      }
    }

    this.instance = new Swiper(this.el, config)
    gsap.to(this.el, {
      opacity: 1,
      duration: 1,
      ease: 'power2.Out'
    })
  }

  disableSwiper () {
    if (!this.instance) return
    this.instance.destroy(true, true)
    this.instance = null
  }
}
